const Airtable = require('airtable');

Airtable.configure({
  endpointUrl: 'https://api.airtable.com',
  apiKey: 'keyS1S94Y0h4r7LEw'
});
const base = Airtable.base('appKUXvvuGcO6Vj8p');

export const update = async (element, id, fields) => {
  try {
    const updated = await base(element).update([
      {
        id: id,
        fields: fields
      }
    ]);
    if (updated.length) {
      return { success: true, data: updated[0] };
    } else {
      return { success: false, data: null };
    }
  } catch (ex) {
    console.log(`Failed to update ${element} : `, ex);
    return { success: false, data: null };
  }
};

export const getReference = async (baseName, ClientID, leadID, View) => {
  try {
    const response = await base(baseName)
      .select({
        filterByFormula: `AND({Record ID}='${leadID}',{Client Record ID}='${ClientID}')`,
        view: View || 'UI_DefaultView'
      })
      .all();

    if (response.length) {
      return { success: true, data: response[0] };
    } else {
      return { success: true, data: null };
    }
  } catch (ex) {
    console.log('Failed to get reference: ', ex);
    return { success: false, data: null };
  }
};

export const getElementById = async (element, id) => {
  try {
    var response = await base(element).find(id);
    if (response.fields) {
      return { success: true, data: response.fields };
    } else {
      return { success: false };
    }
  } catch (ex) {
    console.log(`Failed to get element ${element} with id ${id}: `, ex);
    return { success: false, error: ex };
  }
};

export const allConfigs = async (element) => {
  try {
    var response = await base(element).select({}).all();

    if (response) {
      return { success: true, data: response };
    } else {
      return { success: false };
    }
  } catch (ex) {
    console.log('Exception in getting all elements: ', ex);
    return { success: false, error: ex };
  }
};

// https://api.airtable.com/v0/appKUXvvuGcO6Vj8p/Leads?view=<VIEW>&filterByFormula=%7BRecord%20ID%7D%3D%27<RECORDID>%27

// export default (app, apiKey) => {
//   // Airtable.configure({
//   //   endpointUrl: 'https://api.airtable.com',
//   //   apiKey,
//   // });
//   // const base = Airtable.base(app);

//   Airtable.configure({
//     endpointUrl: 'https://api.airtable.com',
//     apiKey: 'keyS1S94Y0h4r7LEw'
//   });
//   const base = Airtable.base('appKUXvvuGcO6Vj8p');

//   return {
//     getReference: async (baseName, key, value) => {
//       try {
//         const response = await base(baseName)
//           .select({
//             filterByFormula: `{${key}} = '${value}'`
//           })
//           .all();
//         return response.length ? response[0] : null;
//       } catch (ex) {
//         console.log('Failed to get reference: ', ex);
//       }
//       return null;
//     },

//     getReferenceAll: async (baseName, key, value) => {
//       try {
//         return await base(baseName)
//           .select({
//             filterByFormula: `{${key}} = '${value}'`
//           })
//           .all();
//       } catch (ex) {
//         console.log('Failed to get reference: ', ex);
//       }
//       return [];
//     },

//     getReferenceDoubleMatch: async (baseName, key1, value1, key2, value2) => {
//       try {
//         value1 = value1.replace(/'/g, "\\'");
//         const response = await base(baseName)
//           .select({
//             filterByFormula: `AND({${key1}} = '${value1}', {${key2}} = '${value2}')`
//           })
//           .all();
//         return response.length ? response[0] : null;
//       } catch (ex) {
//         console.log('Failed to get reference: ', ex);
//       }
//       return null;
//     },

//     search: async (baseName, key, value) => {
//       try {
//         const response = await base(baseName)
//           .select({
//             filterByFormula: `AND(FIND('${value}', {${key}}) > 0, {${key}} != '')`
//           })
//           .all();
//         return response.length ? response[0] : null;
//       } catch (ex) {
//         console.log('Failed to get reference: ', ex);
//       }
//       return null;
//     },

//     getElementById: async (element, id) => {
//       try {
//         return await base(element).find(id);
//       } catch (ex) {
//         console.log(`Failed to get element ${element} with id ${id}: `, ex);
//       }
//       return null;
//     },

//     create: async (element, fields) => {
//       try {
//         return (
//           await base(element).create([
//             {
//               fields
//             }
//           ])
//         )[0];
//       } catch (ex) {
//         console.log(`Failed to create ${element}: `, ex);
//       }
//       return null;
//     },

//     createMany: async (element, records) => {
//       try {
//         await base(element).create(records);
//       } catch (ex) {
//         console.log(`Failed to create ${element}: `, ex);
//       }
//     },

//     update: async (element, id, fields) => {
//       try {
//         const updated = await base(element).update([
//           {
//             id: id,
//             fields: fields
//           }
//         ]);
//         return updated.length && updated[0];
//       } catch (ex) {
//         console.log(`Failed to update ${element} : `, ex);
//       }
//       return null;
//     },

//     updateMany: async (element, records) => {
//       try {
//         await base(element).update(records);
//       } catch (ex) {
//         console.log('Failed to update many records: ', ex);
//       }
//     },

//     replace: async (element, id, fields) => {
//       try {
//         return await base(element).replace([
//           {
//             id,
//             fields
//           }
//         ]);
//       } catch (ex) {
//         console.log(`Failed to replace: ${element} : `, ex);
//       }
//       return null;
//     },

//     replaceMany: async (element, records) => {
//       try {
//         await base(element).replace(records);
//       } catch (ex) {
//         console.log('Failed to replace many records: ', ex);
//       }
//     },

//     all: async (element) => {
//       try {
//         return await base(element).select({}).all();
//       } catch (ex) {
//         console.log('Exception in getting all elements: ', ex);
//       }
//       return [];
//     },

//     delete: async (element, records) => {
//       try {
//         await base(element).destroy(records);
//       } catch (ex) {
//         console.log('Failed to delete records: ', records, ex);
//       }
//     },

//     getReferenceContains: async (baseName, key, value) => {
//       const formatted = value.replace(/"/g, '\\"');
//       try {
//         return await base(baseName)
//           .select({
//             filterByFormula: `FIND({${key}}, "${formatted}") > 0`
//           })
//           .all();
//       } catch (ex) {
//         console.log('Failed to get reference: ', ex);
//       }
//       return [];
//     },

//     getReferenceTripleMatch: async (
//       baseName,
//       key1,
//       value1,
//       key2,
//       value2,
//       key3,
//       value3
//     ) => {
//       try {
//         return await base(baseName)
//           .select({
//             filterByFormula: `AND(FIND('${value1}', {${key1}}) > 0, {${key2}} = '${value2}', {${key3}} = '${value3}')`
//           })
//           .all();
//       } catch (ex) {
//         console.log('Failed to get reference: ', ex);
//       }
//       return [];
//     }
//   };
// };
